@if (showEditor$ | async) {
  <div style="display: block; width: 100%;">
    <div class="code-container" styles="display: block; width: 100%; position: relative">
      <code-editor [ngModel]="code$ | async" setup="basic" [lineWrapping]="true" [indentUnit]="jsonEditorIndentUnit" [extensions]="jsonEditorExtensions" (ngModelChange)="onCodeChanged($event)" style="width: 100%;"></code-editor>
    </div>
  </div>
}
